export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL}/api/v1` : 'http://localhost:8080/api/v1';

export const WEBAPPADMIN = "webapp.admin";
export const WEBAPPOPERATOR = "webapp.operator";
export const SUPERADMIN = "super.admin";

export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth/change_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth/refresh_token`,
  },
  CROP_VARIETY_MACHINE: {
    GET_CROPS_AND_VARIETIES: `${BASE_API_URL}/desktop/crop-variety-machine-mgmt/get_crops_by_id`,
    GET_MACHINES: `${BASE_API_URL}/desktop/crop-variety-machine-mgmt/get_machines_by_id`,
  },
  SCAN: {
    GET_USER_SCAN_HISTORY: `${BASE_API_URL}/desktop/scan-mgmt/get_user_scan_history`,
    GET_SCAN_PDF: `${BASE_API_URL}/desktop/scan-mgmt/get_scan_pdf`,
    POST_SCAN_METADATA: `${BASE_API_URL}/desktop/scan-mgmt/create_scan_metadata`,
    POST_SCAN_RESULT: `${BASE_API_URL}/desktop/scan-mgmt/update_scan`,
    POST_SCAN_FILES: `${BASE_API_URL}/desktop/scan-mgmt/create_scan_file`,
    GET_UPDATED_SCAN_PDF: `${BASE_API_URL}/desktop/scan-mgmt/get_updated_scan_pdf`,
  },
  METADATA: {
    GET_METADATA_BY_COMPANY_ID: `${BASE_API_URL}/desktop/metadata-mgmt/get_metadata_by_company_id`,
  },
};
